/**
 * Intended to be used to fulfil the react/no-object-type-as-default-prop rule.
 * https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/no-object-type-as-default-prop.md
 */
export var emptyObject = {};
Object.freeze(emptyObject);
//# sourceMappingURL=js.js.map